import PropTypes from 'prop-types';
import { Typography } from '@mui/material';

/** Marque une valeur absente de façon identique partout. */
const EmptyValue = ({ children = '—' }) => (
  <Typography sx={{ fontSize: '0.8rem', color: 'text.disabled' }}>
    {children}
  </Typography>
);

EmptyValue.propTypes = {
  children: PropTypes.node
};

export default EmptyValue;
